import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export interface GoogleAccount {
    id: string;
    email: string;
    verified_email: boolean;
    name: string;
    given_name: string;
    family_name: string;
    picture: string;
}

type GoogleAccountState = {
    isLoadingGoogleAccount: boolean;
    setIsLoadingGoogleAccount: (isLoading: boolean) => void;
    googleAccount: GoogleAccount | null;
    setGoogleAccount: (account: GoogleAccount) => void;
    clearGoogleAccount: () => void;
}

export const useGoogleAccountStore = create<GoogleAccountState>()(
    persist(
        (set) => ({
            isLoadingGoogleAccount: false,
            setIsLoadingGoogleAccount: (isLoading) => set({ isLoadingGoogleAccount: isLoading }),
            googleAccount: null,
            setGoogleAccount: (account) => set({ googleAccount: account }),
            clearGoogleAccount: () => set({ googleAccount: null }),
        }),
        {
            name: 'google-account-storage',
        }
    )
);

